class FacebookService {
	initialize() {
		// The Facebook SDK is not initialised on web.
	}
}

export default new FacebookService();
